const PRODUCTION_HOSTNAMES = new Set([
  "k3eus-ai-chat-prd.azurewebsites.net",
  "kc-chat.knowledgecubed.com",
]);
const getOktaConfig = () => {
  const hostname = window.location.hostname;

  const stagingConfig = {
    clientId: "0oal7u7b88HO9byga1d7",
    // QA KC Okta Issuer
    issuer:
      "https://login-sandbox.knowledgecubed.com/oauth2/ausa36sfnlgwaRdPc1d7",
    redirectUri: window.location.origin + "/login-callback",
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: true,
    disableHttpsCheck: false,
  };

  const productionConfig = {
    clientId: "0oara1539anNxyi80697",
    issuer: "https://login.knowledgecubed.com/oauth2/ausieh9rcAflUSFz8696",
    redirectUri: window.location.origin + "/login-callback",
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: true,
    disableHttpsCheck: false,
  };
  if (PRODUCTION_HOSTNAMES.has(hostname)) {
    console.log("Using production Okta config");
    return productionConfig;
  }

  // Default to staging for all other hostnames
  console.log("Using staging Okta config");
  return stagingConfig;
};

const oktaConfig = getOktaConfig();

export default oktaConfig;
